import D_NA from './NA';
import D_NA1 from './NA1';
import D_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const NA_SITES: string[] = ['us', 'ca', 'za'];

    return <>{NA_SITES.includes(locale) ? locale === 'za' ? <D_NA /> : <D_NA1 /> : <D_Other />}</>;
}
